const hasChannelWithoutFullPostingPermissions = ({
  channelsSelected,
  listOfChannels,
}) => {
  if (!channelsSelected || !listOfChannels) return null;
  const listOfChannelsFiltered = listOfChannels.filter(channel =>
    channelsSelected.includes(channel.id)
  );
  return listOfChannelsFiltered.some(channel => channel.isManager === false);
};

export default hasChannelWithoutFullPostingPermissions;
